export class CdApprovalListHelper {

    static ApprovalListFileName = "История согласования.html";
    static AcquaintanceListFileName = "История ознакомления.html";
    static ApprovalListName = "PkApprovalList";
  }